import { Fragment, useCallback, useRef, useState } from 'react';

import { playSound, Sound } from '~/assets/sounds';
import { rage } from '~/rage';

import { Button } from '../../components/Button';
import { PanelContainer } from '../../components/PanelContainer';
import { TextInput } from '../../components/TextInput';
import { TextLabel } from '../../components/TextLabel';
import {
	StyledButtonContainer,
	StyledInputContainer,
	StyledQuotes,
} from './ServerPassword.styled';

const ServerPassword = () => {
	const [loading, setLoading] = useState(false);

	const passwordRef = useRef<HTMLInputElement>(null);
	const handleSubmit = useCallback(async () => {
		const password = passwordRef.current?.value;
		if (loading || !password || password.length === 0) {
			return;
		}

		setLoading(true);
		try {
			await rage.accounts.verifyServerPassword(password);
		} catch (error) {
			rage.notifications.showException(error);
		}
		setLoading(false);
	}, [loading]);

	return (
		<Fragment>
			<PanelContainer>
				<StyledQuotes />
				<TextLabel
					style={{
						fontSize: 20,
						fontWeight: 500,
						color: '#ffffff',
						opacity: 0.5,
					}}
				>
					Извините :(
				</TextLabel>
				<TextLabel
					style={{
						marginTop: 22,
						fontSize: 16,
						color: '#ffffff',
						opacity: 0.25,
						textAlign: 'center',
					}}
				>
					Сервер находится на тех.работах
					<br />
					Ожидайте новостей в наших сообществах!
				</TextLabel>
				<StyledInputContainer>
					<TextInput ref={passwordRef} placeholder="Введите пароль" />
				</StyledInputContainer>
				<StyledButtonContainer>
					<Button
						name="login"
						loading={loading}
						onClick={() => {
							handleSubmit();
							playSound(Sound.ClickButton);
						}}
						primary
						onMouseEnter={() => playSound(Sound.LinkCursor)}
						tabIndex={-1}
					>
						Войти
					</Button>
				</StyledButtonContainer>
			</PanelContainer>
		</Fragment>
	);
};

export { ServerPassword };
